import React from "react";
import EditBottomComponent from "../../../CoreComponents/EditBottomComponent";
import MapView from "../MapView";
import RadiusField from "./RadiusField";
import ImageUploadWithCrop from "../../../CoreComponents/ImageUploadWithCrop";
import {
  is_superuser,
  works_in_franchise,
} from "../../../Functionalities/Config";
import { PICTURE_SHAPES } from "../../../Functionalities/pictureShapes";

function RestaurantEditForm({
  data,
  setData,
  coordOb,
  setCoordObj,
  compression,
  setCompression,
  setEdit,
  setErrors,
  apiKey,
  handleCoordinatesChange,
  validateEmail,
  ManageRestaurant,
  showMessage,
}) {
  return (
    <div className="col-xl-12 col-lg-12">
      <div className="card">
        <div className="card-body">
          <div className="basic-form">
            <form>
              {/* Admin edit section is condition based start */}
              {works_in_franchise &&
              data.adminEdit ? (
                <>
                  <div className="card-header">
                    <h4 className="card-title">Edit Admin Section</h4>
                  </div>
                  <div className="card-body">
                    <div className="basic-form">
                      <div className="form-row">
                        <div className="form-group col-md-6">
                          <label>
                            Name <span className="required">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={data.admin_name}
                            onChange={(e) => {
                              setData({
                                ...data,
                                admin_name: e.target.value,
                              });
                            }}
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label>
                            Username <span className="required">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={data.admin_username}
                            onChange={(e) => {
                              setData({
                                ...data,
                                admin_username: e.target.value,
                              });
                            }}
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label>Password</label>
                          <input
                            type="password"
                            className="form-control"
                            value={data.admin_password}
                            onChange={(e) => {
                              setData({
                                ...data,
                                admin_password: e.target.value,
                              });
                            }}
                          />
                        </div>
                        {data.admin_password && (
                          <div className="form-group col-md-6">
                            <label>
                              Confirm Password{" "}
                              <span className="required">*</span>
                            </label>
                            <input
                              type="password"
                              className="form-control"
                              value={data.confirm_admin_password}
                              onChange={(e) => {
                                setData({
                                                  ...data,
                                                  confirm_admin_password:
                                                    e.target.value,
                                                });
                              }}
                            />
                          </div>
                        )}
                        <div className="form-group col-md-6">
                          <label>
                            Mobile
                          </label>
                          <input
                            type="number"
                            min={0}
                            className="form-control"
                            onKeyDown={(evt) =>
                              ((evt.key === "e" || evt.key === "-") &&
                                evt.preventDefault()) ||
                              (evt.key === "E" && evt.preventDefault())
                            }
                            onWheelCapture={(e) => {
                              e.target.blur();
                            }}
                            value={data.admin_mobile}
                            onChange={(e) => {
                              setData({
                                                ...data,
                                                admin_mobile:
                                                  e.target.value.slice(0, 10),
                                              });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  {works_in_franchise && (
                    <div className="text-right">
                      <a
                        href="javascript:void()"
                        className="btn btn-primary mb-1"
                        onClick={(e) => {
                          e.preventDefault();
                          setData((prev) => ({ ...prev, adminEdit: true }));
                        }}
                      >
                        Admin Edit
                      </a>
                    </div>
                  )}
                </>
              )}
              {/* Admin edit section is condition based end */}
              <div className="card-header">
                <h4 className="card-title">Edit Restaurant Details</h4>
              </div>
              <br></br>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  Restaurant name <span className="required">*</span>
                </label>
                <div className="col-sm-9">
                  <input
                    value={data.branch_name}
                    onChange={(e) =>
                      setData((prev) => ({
                        ...prev,
                        branch_name: e.target.value,
                      }))
                    }
                    type="text"
                    className="form-control"
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  Email <span className="required"></span>
                </label>
                <div className="col-sm-9">
                  <input
                    value={data.email}
                    onChange={(e) => {
                      setData((prev) => ({ ...prev, email: e.target.value }));
                    }}
                    type="text"
                    className="form-control"
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  Mobile <span className="required">*</span>
                </label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    onKeyDown={(evt) =>
                      ((evt.key === "e" || evt.key === "-") &&
                        evt.preventDefault()) ||
                      (evt.key === "E" && evt.preventDefault())
                    }
                    onWheelCapture={(e) => {
                      e.target.blur();
                    }}
                    value={data.mobile}
                     onChange={(e) =>
                       setData(prev => ({
                         ...prev,
                         mobile: e.target.value.slice(0, 10),
                       }))
                     }
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  Fssai Code <span className="required">*</span>
                </label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    onKeyDown={(evt) =>
                      ((evt.key === "e" || evt.key === "-") &&
                        evt.preventDefault()) ||
                      (evt.key === "E" && evt.preventDefault())
                    }
                    onWheelCapture={(e) => {
                      e.target.blur();
                    }}
                    value={data.fssai}
                    onChange={(e) => {
                      const val = e.target.value.slice(0, 14);
                      setData((prev) => ({
                        ...prev,
                        fssai: val,
                      }));
                    }}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  Expense meter in ₹ <span className="required">*</span>
                </label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    value={data.expence_meter}
                    onChange={(e) =>
                      setData((prev) => ({
                        ...prev,
                        expence_meter: e.target.value,
                      }))
                    }
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  Self Pickup Enabled?
                </label>
                <div className="col-sm-9">
                  <select
                    className="form-control"
                    value={data?.self_pickup}
                    onChange={(e) => {
                      setData((prev) => ({
                        ...prev,
                        self_pickup: e.target.value === "true",
                      }));
                    }}
                  >
                    <option value="true">True</option>
                    <option value="false">False</option>
                  </select>
                </div>
              </div>

              {data.self_pickup && (
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">
                    Store charge for self-pickup orders (blank = same as normal)
                  </label>
                  <div className="col-sm-9">
                    <input
                      type="number"
                      min={0}
                      className="form-control"
                      onWheelCapture={(e) => {
                        e.target.blur();
                      }}
                      onKeyDown={(evt) =>
                        ((evt.key === "e" || evt.key === "-") &&
                          evt.preventDefault()) ||
                        (evt.key === "E" && evt.preventDefault())
                      }
                      value={data.self_pickup_restaurent_charge}
                      onChange={(e) =>
                        setData((prev) => ({
                          ...prev,
                          self_pickup_restaurent_charge: e.target.value,
                        }))
                      }
                    />
                  </div>
                </div>
              )}

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  Pure Veg Restaurant?
                </label>
                <div className="col-sm-9">
                  <select
                    className="form-control"
                    value={data?.pure_veg}
                    onChange={(e) => {
                      setData((prev) => ({
                        ...prev,
                        pure_veg: e.target.value === "true",
                      }));
                    }}
                  >
                    <option value="true">True</option>
                    <option value="false">False</option>
                  </select>
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  Is Celebration Store?
                </label>
                <div className="col-sm-9" style={{ display: "flex", alignItems: "center" }}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    style={{ marginLeft: 0, marginTop: 0 }}
                    checked={data?.is_celebration_store || false}
                    onChange={(e) => {
                      setData((prev) => ({
                        ...prev,
                        is_celebration_store: e.target.checked,
                      }));
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Cake store</label>
                <div className="col-sm-9" style={{ display: "flex", alignItems: "center" }}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    style={{ marginLeft: 0, marginTop: 0 }}
                    checked={data?.is_cake_store || false}
                    onChange={(e) => {
                      setData((prev) => ({
                        ...prev,
                        is_cake_store: e.target.checked,
                      }));
                    }}
                  />
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Free delivery</label>
                <div className="col-sm-9 d-flex align-items-center">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    style={{ marginLeft: 0, marginTop: 0 }}
                    checked={data?.free_delivery || false}
                    onChange={(e) => setData((prev) => ({ ...prev, free_delivery: e.target.checked }))}
                  />
                  <small className="text-muted ml-2">Customers pay ₹0 for delivery; the real charge is still recorded and paid to the rider.</small>
                </div>
              </div>

              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  Average Cooking Time (in minutes){" "}
                  <span className="required">*</span>
                </label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    value={data.time_to_cook}
                    onKeyDown={(evt) =>
                      ((evt.key === "e" || evt.key === "-") &&
                        evt.preventDefault()) ||
                      (evt.key === "E" && evt.preventDefault())
                    }
                     onChange={(e) =>
                       setData(prev => ({
                         ...prev,
                         time_to_cook: e.target.value,
                       }))
                     }
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  Restaurant Radius
                </label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    value={data?.radius}
                    onKeyDown={(evt) =>
                      ((evt.key === "e" || evt.key === "-") &&
                        evt.preventDefault()) ||
                      (evt.key === "E" && evt.preventDefault())
                    }
                    onWheelCapture={(e) => {
                      e.target.blur();
                    }}
                    onChange={(e) =>
                      setData((prev) => ({ ...prev, radius: e.target.value }))
                    }
                  />
                </div>
              </div>

              <RadiusField
                value={data?.available_radius}
                onChange={(available_radius) => setData((prev) => ({ ...prev, available_radius }))}
              />
              <div className="form-group row">
                <label className="col-sm-4 col-form-label">
                  Location <span className="required">*</span>
                </label>
              </div>

              {apiKey !== undefined ? (
                <div
                  style={{
                    marginBottom: 20,
                    border: "1px solid #69ff76",
                    padding: 10,
                    borderRadius: 20,
                  }}
                >
                  <MapView
                    onChange={handleCoordinatesChange}
                    coordinates={{
                      lat: parseFloat(coordOb.latitude || 0),
                      lng: parseFloat(coordOb.longitude || 0),
                    }}
                  />
                </div>
              ) : (
                <div>
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Latitude</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        required
                        value={coordOb.latitude}
                        onChange={(e) =>
                          setCoordObj((prev) => ({
                            ...prev,
                            latitude: e.target.value,
                          }))
                        }
                      ></input>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Longitude</label>
                    <div className="col-sm-9">
                      <input
                        type="number"
                        className="form-control"
                        required
                        value={coordOb.longitude}
                        onChange={(e) =>
                          setCoordObj((prev) => ({
                            ...prev,
                            longitude: e.target.value,
                          }))
                        }
                      ></input>
                    </div>
                  </div>
                </div>
              )}
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  Address <span className="required">*</span>
                </label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    value={coordOb.address}
                    onChange={(e) =>
                      setCoordObj({
                        ...coordOb,
                        address: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  Description <span className="required">*</span>
                </label>
                <div className="col-sm-9">
                  <textarea
                    className="form-control"
                    rows="4"
                    id="comment"
                    value={data.description}
                    onChange={(e) =>
                      setData({
                        ...data,
                        description: e.target.value,
                      })
                    }
                  ></textarea>
                </div>
              </div>
              <br />
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">
                  Images (94x76) <span className="required"></span>
                  <br />
                  <b>Compress image </b>
                  <input
                    type="checkbox"
                    checked={compression}
                    onChange={(e) => {
                      setCompression(e.target.checked);
                      setData(prev => ({ ...prev, latestImage: [] }));
                    }}
                  />
                </label>
                <div className="col-sm-9">
                  <ImageUploadWithCrop
                    value={data.latestImage}
                    onChange={(file) =>
                      setData(prev => ({
                        ...prev,
                        latestImage: file,
                      }))
                    }
                    {...PICTURE_SHAPES.restaurant}
                    compress={compression}
                  />
                </div>
              </div>
              <EditBottomComponent
                cancelButton={(e) => {
                  e.preventDefault();
                  setEdit(false);
                }}
                saveButton={(e) => {
                  e.preventDefault();
                  setErrors([]);

                  if (data.adminEdit) {
                    if (data.admin_name === "") {
                      setErrors(["Admin name"]);
                      return;
                    }
                    if (data.admin_username === "") {
                      setErrors(["Admin username"]);
                      return;
                    }
                    if (data.admin_mobile && data.admin_mobile.length < 10) {
                      setErrors(["Admin Mobile number must be 10 number"]);
                      return;
                    }
                    if (
                      data.admin_password !== data.confirm_admin_password
                    ) {
                      setErrors(["Admin passwords not match"]);
                      return;
                    }
                  }

                  if (data.branch_name === "") {
                    setErrors(["Restaurant name"]);
                    return;
                  }
                  if (!data.mobile) {
                    setErrors(["Restaurant mobile"]);
                    return;
                  } else {
                    if (data.mobile.length < 10) {
                      setErrors([" Mobile number must be 10 number"]);
                      return;
                    }
                  }

                  if (data.fssai === "" || data.fssai <= 0) {
                    setErrors(["Restaurant Fssai code"]);
                    return;
                  }
                  if (data.expence_meter === "") {
                    setErrors(["Expence Meter"]);
                    return;
                  }
                  if (data.time_to_cook === "") {
                    setErrors(["Average cooking time"]);
                    return;
                  }
                  if (data.email) {
                    if (!validateEmail(data.email)) {
                      setErrors(["Invalid Email"]);
                      return;
                    }
                  }
                  if (coordOb.latitude === "") {
                    setErrors(["Please choose a location on map"]);
                    return;
                  }
                  if (coordOb.longitude === "") {
                    setErrors(["Please choose a location on map"]);
                    return;
                  }
                  if (coordOb.address === "") {
                    setErrors(["Please choose a location on map"]);
                    return;
                  }

                  let res = ManageRestaurant(
                    e,
                    {
                      ...data,
                      address: coordOb.address,
                      latitude: coordOb.latitude,
                      longitude: coordOb.longitude,
                    },
                    "update",
                    ""
                  );
                  res.then((res) => {
                    if (res) {
                      if (res.data.Status === true) {
                        showMessage(
                          "Restaurant successfully updated",
                          "success",
                          "Success!",
                          "top",
                          "top-right",
                          0
                        );
                        setEdit(false);
                      } else {
                        showMessage(
                          res.data.Error,
                          "danger",
                          "Restaurant update error",
                          "top",
                          "top-right",
                          0
                        );
                      }
                    } else {
                      showMessage(
                        "error",
                        "danger",
                        "Restaurant update error",
                        "top",
                        "top-right",
                        0
                      );
                    }
                  });
                }}
              />
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RestaurantEditForm;
